"use strict";
var DynamicComponent_1 = require('./DynamicComponent');
exports.DynamicComponent = DynamicComponent_1.DynamicComponent;
exports.DynamicComponentMetadata = DynamicComponent_1.DynamicComponentMetadata;
var DynamicComponentModule_1 = require('./DynamicComponentModule');
exports.DynamicComponentModule = DynamicComponentModule_1.DynamicComponentModule;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular2-dynamic-component/index.js
 ** module id = 529
 ** module chunks = 0
 **/